// extracted by mini-css-extract-plugin
export var cardLink = "CardAsLink-module--cardLink--38758";
export var srOnly = "CardAsLink-module--srOnly--37bd6";